export enum EInstallTestState {
  OK = "OK",
  NOK = "NOK",
  UNKNOWN = "UNKNOWN",
}
